import { useCallback, useState } from 'react'
import { flushSync } from 'react-dom'
import TextArea from '../../../../../../../../../forms/Input/TextArea'
import { twinFetchPostText } from '../../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../../baseComponents/Modal'
import { ModalOpenedSetTy } from '../../../../../../../../../baseComponents/Modal/types'
import TwinTrans from '../../../../../../../../../baseComponents/TwinTrans'
import { OrderData } from '../../../../../types'
import { OnChangeOrderTableLogicProps } from '../../../../useOrderTableHooks'
import { getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'

interface NotesOrderModalProps extends NotesOrderModalLogicProps {
    setOpened: ModalOpenedSetTy
}

const NotesOrderModal: React.FC<NotesOrderModalProps> = ({ setOpened, ...rest}) => {
    const { updateNotes, setTextAreaValue, textAreaValue } = useNotesOrderModalLogic({ ...rest })
    const userPermissions = getUserPermissions('quote.order')
    const permission = permissionCheck(userPermissions, 'update')
    const {t} = useTwinTranslation()
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened} className='big_small_centered'>
            <div>
                <h2><TwinTrans transKey='editNotes'>Editar notas</TwinTrans></h2>
                <TextArea className='mt-15' label={t('notes', 'Notas')} placeholder={t('writeYourNotes', 'Escribe tus notas')} onChange={setTextAreaValue} value={textAreaValue} readOnly={!permission} />
            </div>
            <ButtonsModalSmallCentered confirmText={t('accept', 'Aceptar')} setOpened={setOpened} onAccept={updateNotes} disabled={!permission} />
        </ModalSmallCentered>
    )
}

interface NotesOrderModalLogicProps extends OnChangeOrderTableLogicProps {
    completeData: OrderData
}

const useNotesOrderModalLogic = ({setCompleteData, inputTableURLs, completeData}: NotesOrderModalLogicProps) => {
    const [textAreaValue, setTextAreaValue] = useState(completeData.header['notes'] || '')
    const updateNotes = useCallback(async () => {
        let result: TwinDictionary = {}
        await flushSync(() => {
            setCompleteData((oldData: any) => {
                if (!oldData) {
                    return null
                }
                oldData.header['notes'] = textAreaValue
                result = {...oldData.header}
                return { ...oldData }
            })
        })
        await twinFetchPostText(inputTableURLs.updateHeaderData, {id: result.id, notes: textAreaValue})
    }, [textAreaValue, inputTableURLs.updateHeaderData, setCompleteData])

    return {updateNotes, setTextAreaValue, textAreaValue}
}

export default NotesOrderModal